export default __webpack_public_path__ + "static/media/hindi_book_f.9d7d5f52.wav";